import { render, staticRenderFns } from "./TrainerView.vue?vue&type=template&id=09f6eff0"
import script from "./TrainerView.vue?vue&type=script&lang=js"
export * from "./TrainerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports